import { IIconProps } from "@/components/icons/interface";
import { HpDeleteIcon } from "@/themes/hp-client/icons/HpDeleteIcon";
import { useTheme } from "@/contexts/theme/useTheme";
import { useGomakeTheme } from "@/hooks/use-gomake-thme";

const DeleteIcon = ({ width, height, color }: IIconProps) => {
  const { primaryColor } = useGomakeTheme();
  const strokeColor = color || primaryColor(300);
  const { currentTheme } = useTheme();
  if (currentTheme === "hp-client") {
    return (
      <HpDeleteIcon
        color={color ?? "var(--theme-combobox-icon-color, #1A1A1A)"}
        width={width ?? 24}
        height={height ?? 24}
      />
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? 20}
      height={height ?? 20}
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 11v6" />
      <path d="M14 11v6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
      <path d="M3 6h18" />
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  );
};

export { DeleteIcon };
